import React from 'react';
import T from '@prisjakt/ui-translate';

import * as S from './styles';

type Props = {
  onClick: () => void;
};

const ConfirmRearrange = ({ onClick }: Props) => {
  return (
    <S.ConfirmRearrangeButtonWrapper>
      <S.ConfirmRearrangeButton
        color="positive"
        onClick={onClick}
        style={{ width: '100%' }}
      >
        <T domain="lists">list.change-order-done</T>
      </S.ConfirmRearrangeButton>
    </S.ConfirmRearrangeButtonWrapper>
  );
};

export default ConfirmRearrange;
